import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const CircleWarningIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="alert-circle" {...props} />;
};

export { CircleWarningIcon };
